import { DashboardConfigConstants } from './DashboardConfig.constants';

const initialState = {
  dashboard: {},
  response: {},
  selected_chart_deviation: [],
  dashboardConfigs: {},
  historicalStatusConfigs: {},
  dashboardTableConfigs: {},
  groupType: '',
  groupTypeChannels: [],
  subMenu: '',
  groupSourceNameSwitch: true,
  sourceGroupCheckList:{}
};

const DashboardConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case DashboardConfigConstants.GET_CHART_QUERY_CONFIGS_REQUEST:
      return {
        ...state,
        response: {
          loading: true,
          error: false
        }
      };

    case DashboardConfigConstants.GET_CHART_QUERY_CONFIGS_SUCCESS:
      return {
        ...state,
        response: {
          loading: false,
          error: false,
          data: [action.payload]
        }
      };

    case DashboardConfigConstants.GET_CHART_QUERY_CONFIGS_ERROR:
      return {
        ...state,
        response: {
          loading: false,
          error: true
        }
      };

    // --- Dashboard chart config
    case DashboardConfigConstants.GET_DASHBOARD_QUERIES_REQUEST:
      return {
        ...state,
        dashboardConfigs: {
          ...state.dashboardConfigs,
          loading: true,
          error: false
        }
      };

    case DashboardConfigConstants.GET_DASHBOARD_QUERIES_SUCCESS:
      return {
        ...state,
        dashboardConfigs: {
          ...action.payload,
          ...state.dashboardConfigs,
          loading: false,
          error: false
        }
      };

    case DashboardConfigConstants.GET_DASHBOARD_QUERIES_ERROR:
      return {
        ...state,
        dashboardConfigs: {
          loading: false,
          error: true
        }
      };

    // --- Historical status config
    case DashboardConfigConstants.GET_HISTORICAL_STATUS_REQUEST:
      return {
        ...state,
        historicalStatusConfigs: {
          ...state.historicalStatusConfigs,
          loading: true,
          error: false
        }
      };

    case DashboardConfigConstants.GET_HISTORICAL_STATUS_SUCCESS:
      return {
        ...state,
        historicalStatusConfigs: {
          ...action.payload,
          loading: false,
          error: false
        }
      };

    case DashboardConfigConstants.GET_HISTORICAL_STATUS_ERROR:
      return {
        ...state,
        historicalStatusConfigs: {
          loading: false,
          error: true
        }
      };

    // --- Dashboard table config
    case DashboardConfigConstants.GET_DASHBOARD_TABLE_QUERIES_REQUEST:
      return {
        ...state,
        dashboardTableConfigs: {
          ...state.dashboardTableConfigs,
          loading: true,
          error: false
        }
      };

    case DashboardConfigConstants.GET_DASHBOARD_TABLE_QUERIES_SUCCESS:
      return {
        ...state,
        dashboardTableConfigs: {
          ...action.payload,
          ...state.dashboardTableConfigs,
          loading: false,
          error: false
        }
      };

    case DashboardConfigConstants.GET_DASHBOARD_TABLE_QUERIES_ERROR:
      return {
        ...state,
        dashboardTableConfigs: {
          loading: false,
          error: true
        }
      };
    // --- Dashboard chart deviations

    case DashboardConfigConstants.SET_SELECTED_CHART_DEVIATION_SUCCESS:
      return {
        ...state,
        selected_chart_deviation: [...state.selected_chart_deviation, action.payload]
      };

    case DashboardConfigConstants.SET_SELECTED_GROUP:
      return {
        ...state,
        groupType: action.payload
      };

    case DashboardConfigConstants.SET_SELECTED_GROUP_CHANNELS:
      return {
        ...state,
        groupTypeChannels: action.payload
      };

    case DashboardConfigConstants.SET_SELECTED_SUBMENU:
      return {
        ...state,
        subMenu: action.payload
      };
  case DashboardConfigConstants.SET_GROUP_SOURCE_NAME_CHECKED_LIST:
    return {
      ...state,
      sourceGroupCheckList:action.payload
    }

  case DashboardConfigConstants.SET_GROUP_SOURCE_NAME_SWITCH:
    return {
      ...state,
      groupSourceNameSwitch:action.payload
    }

    default:
      return state;
  }
};

export default DashboardConfigReducer;
